import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTaskAcceptance } from "./api";
import type { AcceptanceItemResponse } from "./api";

// Acceptance-чек-лист задачи для TaskDetailPage. Org-scoped запрос
// (см. `src/query/scope.ts`); conditional через `enabled`.
export function useTaskAcceptance(
  taskId: string,
  options?: { readonly enabled?: boolean },
): UseQueryResult<AcceptanceItemResponse[], Error> {
  return useOrgScopedQuery<AcceptanceItemResponse[]>({
    key: ["task-acceptance", taskId],
    queryFn: () => fetchTaskAcceptance(taskId),
    enabled: options?.enabled ?? true,
    retry: false,
  });
}
